import { z } from "zod";
import { userSchema } from "../../user/api/schemas";

export const sendNewMessageUserGuestSchema = z.object({
  email: z
    .string()
    .email({ message: "E-mail Inválido" })
    .min(1, { message: "Campo Obrigatório" }),
  message: z
    .string()
    .min(3, { message: "A mensagem deve conter no mínimo 3 caracteres" })
    .max(500, "A Mensagem deve conter no máximo 500 caracteres"),
  name: z.string().min(1, { message: "Campo Obrigatório" }),
  password: z
    .string()
    .min(6, { message: "A senha deve conter no mínimo 6 caracteres" }),
});

export type SendNewMessageUserGuestType = z.infer<
  typeof sendNewMessageUserGuestSchema
>;

// Message/Chat Response Schemas
const conversationSchema = z.object({
  id: z.string().uuid(),
  realEstateId: z.string().uuid(),
  user1Id: z.string().uuid(),
  user2Id: z.string().uuid(),
  lastMessageAt: z.string().datetime(),
  createdAt: z.string().datetime(),
  updatedAt: z.string().datetime(),
});

const messageSchema = z.object({
  id: z.string().uuid(),
  conversationId: z.string().uuid(),
  senderId: z.string().uuid(),
  content: z.string(),
  createdAt: z.string().datetime(),
});

const tokenSchema = z.object({
  accessToken: z.string(),
});

export const sendMessageSuccessResponseSchema = z.object({
  leadUserId: z.string().uuid(),
  conversation: conversationSchema,
  message: messageSchema,
  tokens: tokenSchema,
  user: userSchema,
});

export type ConversationType = z.infer<typeof conversationSchema>;
export type MessageType = z.infer<typeof messageSchema>;
export type SendMessageSuccessResponseType = z.infer<
  typeof sendMessageSuccessResponseSchema
>;
